import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

const INITIAL_REMINDERS = [
  {
    id: 1,
    reminderFor: "Events",
    frequency: "Before 1 Day",
    time: "09:00 AM",
    recipients: "All Parents",
    active: true,
  },
  {
    id: 2,
    reminderFor: "Events",
    frequency: "Before 2 Days",
    time: "09:00 AM",
    recipients: "All Parents",
    active: true,
  },
  {
    id: 3,
    reminderFor: "Events",
    frequency: "Before 3 Days",
    time: "09:00 AM",
    recipients: "All Parents",
    active: true,
  },
  {
    id: 4,
    reminderFor: "Holidays",
    frequency: "Before 1 Day",
    time: "09:00 AM",
    recipients: "All Parents & Staff",
    active: true,
  },
  {
    id: 5,
    reminderFor: "Holidays",
    frequency: "Before 3 Days",
    time: "09:00 AM",
    recipients: "All Parents",
    active: true,
  },
];

class RemindersTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reminders: [...INITIAL_REMINDERS],
      filterReminderFor: "All",
      filterFrequency: "All Frequencies",
      form: {
        reminderFor: "Events",
        frequency: "Before 1 Day",
        time: "09:00",
        sendToParents: true,
        sendToTeachers: false,
        sendToNonTeaching: false,
        individualClasses: false,
        selectedClasses: "Class 6",
      },
      errors: {},
    };
  }

  handleToggleReminder = (id) => {
    this.setState((prev) => ({
      reminders: prev.reminders.map((r) =>
        r.id === id ? { ...r, active: !r.active } : r
      ),
    }));
  };

  handleDeleteReminder = (id) => {
    this.setState((prev) => ({
      reminders: prev.reminders.filter((r) => r.id !== id),
    }));
  };

  handleReminderForChange = (e) => this.setState({ filterReminderFor: e.target.value });
  handleFrequencyFilterChange = (e) => this.setState({ filterFrequency: e.target.value });

  handleFormChange = (field, val) => {
    this.setState((prev) => ({
      form: { ...prev.form, [field]: val },
      errors: { ...prev.errors, [field]: undefined },
    }));
  };

  validateForm = () => {
    const { form } = this.state;
    const errors = {};
    if (!form.time) errors.time = "Time is required";
    if (!form.sendToParents && !form.sendToTeachers && !form.sendToNonTeaching && !form.individualClasses) {
      errors.sendTo = "Please select at least one recipient under Send To";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.validateForm()) return;
    const { form } = this.state;

    // Recipient list format
    let recipientsList = [];
    if (form.sendToParents) recipientsList.push("All Parents");
    if (form.sendToTeachers) recipientsList.push("All Staff");
    if (form.sendToNonTeaching) recipientsList.push("Non-Teaching Staff");
    if (form.individualClasses) recipientsList.push(form.selectedClasses);
    const recipients = recipientsList.join(" & ");

    const formatTime = (timeStr) => {
      if (!timeStr) return "09:00 AM";
      const [hrs, mins] = timeStr.split(":");
      const hours = parseInt(hrs);
      const ampm = hours >= 12 ? "PM" : "AM";
      const displayHours = hours % 12 || 12;
      const formattedHours = displayHours < 10 ? `0${displayHours}` : displayHours;
      return `${formattedHours}:${mins} ${ampm}`;
    };

    const newReminder = {
      id: Date.now(),
      reminderFor: form.reminderFor,
      frequency: form.frequency,
      time: formatTime(form.time),
      recipients: recipients || "All Parents",
      active: true,
    };
    this.setState((prev) => ({
      reminders: [newReminder, ...prev.reminders],
    }));
    this.props.history.push("/school-activity-management/reminders");
  };

  renderList = (filteredReminders) => {
    const { history } = this.props;

    return (
      <div>
        {/* Table Toolbar */}
        <div className="sam-table-toolbar">
          <div className="sam-toolbar-left">
            <select value={this.state.filterReminderFor} onChange={this.handleReminderForChange}>
              <option value="All">All Categories</option>
              <option value="Events">Events</option>
              <option value="Holidays">Holidays</option>
            </select>
            <select value={this.state.filterFrequency} onChange={this.handleFrequencyFilterChange}>
              <option value="All Frequencies">All Frequencies</option>
              <option value="Before 1 Day">Before 1 Day</option>
              <option value="Before 2 Days">Before 2 Days</option>
              <option value="Before 3 Days">Before 3 Days</option>
              <option value="Weekly">Weekly</option>
            </select>
          </div>
          <button
            className="sam-btn sam-btn-success"
            onClick={() => history.push("/school-activity-management/reminders/create")}
          >
            <i className="fal fa-plus" /> Add Reminder
          </button>
        </div>

        {/* Custom Table */}
        <div className="sam-table-card">
          <table className="sam-table">
            <thead>
              <tr>
                <th>Reminder For</th>
                <th>Frequency</th>
                <th>Time</th>
                <th>Recipients</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredReminders.length > 0 ? (
                filteredReminders.map((reminder) => (
                  <tr key={reminder.id}>
                    <td className="sam-col-bold">{reminder.reminderFor}</td>
                    <td>{reminder.frequency}</td>
                    <td>{reminder.time}</td>
                    <td>{reminder.recipients}</td>
                    <td>
                      <div className="sam-switch-wrapper">
                        <input
                          type="checkbox"
                          className="sam-switch-checkbox"
                          id={`toggle-${reminder.id}`}
                          checked={reminder.active}
                          onChange={() => this.handleToggleReminder(reminder.id)}
                        />
                        <label className="sam-switch-slider" htmlFor={`toggle-${reminder.id}`} />
                      </div>
                    </td>
                    <td>
                      <button
                        className="sam-action-btn btn-delete"
                        title="Delete"
                        onClick={() => this.handleDeleteReminder(reminder.id)}
                      >
                        <i className="fal fa-trash-alt" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "3rem" }}>
                    <div className="sam-empty-icon" style={{ fontSize: "2rem", color: "#cbd5e1" }}>
                      <i className="fal fa-bell-slash" />
                    </div>
                    <div style={{ fontWeight: 600, color: "#64748b", marginTop: "0.5rem" }}>
                      No reminder settings found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="sam-table-footer">
          <div className="sam-entries-selector">
            Show
            <select defaultValue="10">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            entries
          </div>
          <div className="sam-pagination">
            <button disabled>‹</button>
            <button className="active">1</button>
            <button disabled>›</button>
          </div>
        </div>
      </div>
    );
  };

  renderCreateForm = () => {
    const { history } = this.props;
    const { form, errors } = this.state;

    return (
      <div className="sam-form-card">
        <h6 className="sam-form-section-title">Reminder Settings</h6>
        <form onSubmit={this.handleSubmit}>
          <Row>
            <Col md={6}>
              <div className="form-group">
                <label>
                  Reminder For <span>*</span>
                </label>
                <select
                  value={form.reminderFor}
                  onChange={(e) => this.handleFormChange("reminderFor", e.target.value)}
                >
                  <option value="Events">Events</option>
                  <option value="Holidays">Holidays</option>
                </select>
              </div>

              <div className="form-group">
                <label>
                  Frequency <span>*</span>
                </label>
                <select
                  value={form.frequency}
                  onChange={(e) => this.handleFormChange("frequency", e.target.value)}
                >
                  <option value="Before 1 Day">Before 1 Day</option>
                  <option value="Before 2 Days">Before 2 Days</option>
                  <option value="Before 3 Days">Before 3 Days</option>
                  <option value="Weekly">Weekly</option>
                </select>
              </div>

              <div className="form-group">
                <label>
                  Time <span>*</span>
                </label>
                <input
                  type="time"
                  value={form.time}
                  onChange={(e) => this.handleFormChange("time", e.target.value)}
                />
                {errors.time && <div className="sam-field-error">{errors.time}</div>}
              </div>
            </Col>

            <Col md={6}>
              <div className="form-group">
                <label>
                  Send To <span>*</span>
                </label>
                <div className="checkbox-group">
                  <label className="form-check">
                    <input
                      type="checkbox"
                      checked={form.sendToParents}
                      onChange={(e) => this.handleFormChange("sendToParents", e.target.checked)}
                    />
                    All Parents
                  </label>
                  <label className="form-check">
                    <input
                      type="checkbox"
                      checked={form.sendToTeachers}
                      onChange={(e) => this.handleFormChange("sendToTeachers", e.target.checked)}
                    />
                    All Teaching Staff
                  </label>
                  <label className="form-check">
                    <input
                      type="checkbox"
                      checked={form.sendToNonTeaching}
                      onChange={(e) => this.handleFormChange("sendToNonTeaching", e.target.checked)}
                    />
                    All Non-Teaching Staff
                  </label>
                  <label className="form-check">
                    <input
                      type="checkbox"
                      checked={form.individualClasses}
                      onChange={(e) => this.handleFormChange("individualClasses", e.target.checked)}
                    />
                    Individual Classes
                  </label>
                </div>
                {errors.sendTo && <div className="sam-field-error">{errors.sendTo}</div>}
              </div>

              {form.individualClasses && (
                <div className="form-group">
                  <label>Select Classes</label>
                  <select
                    value={form.selectedClasses}
                    onChange={(e) => this.handleFormChange("selectedClasses", e.target.value)}
                  >
                    <option value="Class 1">Class 1</option>
                    <option value="Class 2">Class 2</option>
                    <option value="Class 3">Class 3</option>
                    <option value="Class 4">Class 4</option>
                    <option value="Class 5">Class 5</option>
                    <option value="Class 6">Class 6</option>
                    <option value="Class 7">Class 7</option>
                    <option value="Class 8">Class 8</option>
                    <option value="Class 9">Class 9</option>
                    <option value="Class 10">Class 10</option>
                  </select>
                </div>
              )}
            </Col>
          </Row>

          <div className="sam-form-footer">
            <button
              type="button"
              className="sam-btn sam-btn-outline"
              onClick={() => history.push("/school-activity-management/reminders")}
            >
              Cancel
            </button>
            <button type="submit" className="sam-btn sam-btn-success">
              Save Reminder
            </button>
          </div>
        </form>
      </div>
    );
  };

  render() {
    const { action } = this.props;
    const { reminders } = this.state;

    if (action === "create") {
      return this.renderCreateForm();
    }

    // Filter
    const filteredReminders = reminders.filter((r) => {
      const matchesFor = this.state.filterReminderFor === "All" || r.reminderFor === this.state.filterReminderFor;
      const matchesFreq = this.state.filterFrequency === "All Frequencies" || r.frequency === this.state.filterFrequency;
      return matchesFor && matchesFreq;
    });

    return this.renderList(filteredReminders);
  }
}

export default RemindersTab;
